import { type ComponentPropsWithoutRef } from 'react'
import styles from './ButtonPrimary.module.scss'

export type ButtonPrimaryProps = ComponentPropsWithoutRef<'button'> & {
    loading?: boolean
    blocked?: boolean
}

const ActivityIndicatorIcon = () => (
    <svg aria-hidden="true" className={styles.spinner} viewBox="0 0 24 24" fill="none">
        <circle className={styles.spinnerTrack} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
        <path
            className={styles.spinnerHead}
            d="M4 12a8 8 0 0 1 8-8"
            stroke="currentColor"
            strokeWidth="4"
            strokeLinecap="round"
        />
    </svg>
)

/**
 * Primary CTA — cloned from @sentinel-legal/forms ButtonPrimary.
 * Uses claim-site accent blue instead of form-ui green.
 */
export const ButtonPrimary = ({
    className = '',
    disabled,
    loading = false,
    blocked = false,
    children,
    ...props
}: ButtonPrimaryProps) => (
    <button
        type="button"
        disabled={disabled || loading}
        aria-busy={loading || undefined}
        aria-disabled={blocked || undefined}
        className={`${styles.root} ${blocked ? styles.blocked : ''} ${className}`.trim()}
        {...props}
    >
        {loading ? <ActivityIndicatorIcon /> : null}
        {children}
    </button>
)
